export enum VendorType {
    DEVELOPER = 1,
    AGENCY = 2
}
export enum VendorType {
    DEVELOPER = 1,
    AGENCY = 2
}
